import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Skeleton from "@mui/material/Skeleton";

import OrderRatingStatisticsOrderEarned from "./components/Profile/OrderRatingStatisticsOrderEarned";
import UserRating from "../UserReviews"
import ShipperInfo from "./components/Profile/ShipperInfo";
import CarrierInfo from "./components/Profile/CarrierInfo";
import BasicInfo from "./components/Profile/BasicInfo";
import useHttp from "../../hooks/useHttp";
import { GET_USER_PROFILE_VALUE_URL } from "../../utils/api-ends";
import { progressing_status } from "../../store/slices/progessingRequest";

const AccountInformation = () => {
  const [userProfileData, setUserProfileData] = useState({});
  const { isLoading, sendRequests } = useHttp();
  const dispatch = useDispatch();
  const userDetail = useSelector((state) => state.basicInfo.userDetails);

  useEffect(() => {
    const response = (data) => {
      setUserProfileData(data);
    };

    // Send request to get profile info
    sendRequests(
      {
        url: GET_USER_PROFILE_VALUE_URL(userDetail?.id),
        method: "GET",
      },
      response
    );
  }, [userDetail?.id, sendRequests]);

  useEffect(() => {
    dispatch(progressing_status(isLoading));
  }, [isLoading , dispatch]);

  return (
    <>
      <BasicInfo userID={userDetail?.id} />
      <section id="profile-info">
        <div className="container theme-section">
          <div className="row">
            <div className="row justify-content-center">
              {userProfileData?.own_profile === true && (
                <div className="row profile-info-section-wrapper position-relative">
                  {!userProfileData && (
                    <Skeleton animation="wave" className="card-animation" />
                  )}
                  <div className="col-lg-4 profile-info-boxes">
                    <label>Bank Account Holder Name</label>
                    <p>{userProfileData?.bank_account_holder_name}</p>
                  </div>

                  <div className="col-lg-4 profile-info-boxes">
                    <label>Bank Name </label>
                    <p>{userProfileData?.bank_name}</p>
                  </div>

                  <div className="col-lg-4 profile-info-boxes">
                    <label>Bank Account Number</label>
                    <p>{userProfileData?.bank_account_number}</p>
                  </div>

                  <div className="col-lg-4 profile-info-boxes">
                    <label>Bank Account Country </label>
                    <p>{userProfileData?.bank_account_country}</p>
                  </div>

                  <div className="col-lg-4 profile-info-boxes">
                    <label>Bank Branch Name </label>
                    <p>{userProfileData?.bank_account_branch_name}</p>
                  </div>
                </div>
              )}
              <div className="row profile-info-section-wrapper position-relative">
                {!userProfileData && (
                  <Skeleton animation="wave" className="card-animation" />
                )}

                {userProfileData.user_type === "shipper" ? (
                  <ShipperInfo
                    company_name={userProfileData?.company_name}
                    licenseNumber={userProfileData.shipper_obj?.license_number}
                    bondingAgent={userProfileData.shipper_obj?.bonding_agent}
                    bondingCoPhoneNumber={
                      userProfileData.shipper_obj?.bonding_co_phone_number
                    }
                    isOwner={true}
                  />
                ) : (
                  <CarrierInfo
                    company_name={userProfileData?.company_name}
                    cargo_Inc_limit={
                      userProfileData.carrier_obj?.cargo_Inc_limit
                    }
                    icc_mc_number={userProfileData.carrier_obj?.icc_mc_number}
                    cargo_insurance_company={
                      userProfileData.carrier_obj?.cargo_insurance_company
                    }
                    liability_Inc_limit={
                      userProfileData.carrier_obj?.liability_Inc_limit
                    }
                    agent_phone={userProfileData.carrier_obj?.agent_phone}
                    Inc_deductible={userProfileData.carrier_obj?.Inc_deductible}
                    driving_licence={
                      userProfileData.carrier_obj?.driving_licence
                    }
                    cargo_Inc_agent={
                      userProfileData.carrier_obj?.cargo_Inc_agent
                    }
                    load_type={userProfileData.carrier_obj?.load_type_name}
                    carrier_type={
                      userProfileData.carrier_obj?.carrier_type_name
                    }
                    vehicle_image_url={userProfileData.carrier_obj?.vehicle_image_url}
                    isOwner={true}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      <OrderRatingStatisticsOrderEarned />

      <UserRating />
    </>
  );
};

export default React.memo(AccountInformation);
